<template>
    <div>
        <text-form-group
                :value="value.list_reference"
                name="list_reference"
                label="List Reference"
                :error="(errors.list_reference || [])[0]"
                @input="input('list_reference', $event)"
        />
    </div>
</template>

<script>
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        methods: {
            input(key, value) {
                this.$emit('input', {...this.value, [key]: value})
            }
        }
    }
</script>
